var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportboxicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.4929 20.9187L41.4836 20.8812L36.2242 7.51719C35.9898 6.7625 35.2914 6.24219 34.4992 6.24219H13.1804C12.3836 6.24219 11.6757 6.77188 11.4507 7.53594L6.53355 20.7641L6.51949 20.7969L6.51012 20.8344C6.44918 21.0641 6.43043 21.2984 6.46324 21.5281C6.45855 21.6031 6.45387 21.6781 6.45387 21.7531V38.9047C6.45511 39.6602 6.75577 40.3844 7.28998 40.9186C7.82419 41.4528 8.54838 41.7534 9.30387 41.7547H38.7039C40.2742 41.7547 41.5539 40.475 41.5586 38.9047V21.7531C41.5586 21.6922 41.5586 21.6312 41.5539 21.5797C41.5726 21.35 41.5539 21.1297 41.4929 20.9187ZM27.6273 18.9031L27.6132 19.6391C27.5757 21.7437 26.1226 23.1594 23.9992 23.1594C22.9632 23.1594 22.0726 22.8266 21.4304 22.1937C20.7882 21.5609 20.4367 20.6797 20.4179 19.6391L20.4039 18.9031H10.757L14.4836 9.84219H33.1961L37.0257 18.9031H27.6273ZM10.0492 22.5031H17.4226C18.5617 25.1797 20.9851 26.7594 24.0039 26.7594C25.5836 26.7594 27.0507 26.3187 28.2367 25.4844C29.2773 24.7531 30.0882 23.7312 30.6132 22.5031H37.9492V38.1547H10.0492V22.5031Z",
    fill: "#1677FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportboxicon);
export default __webpack_public_path__ + "static/media/importboxicon.e7bdf9ec9119ff2492211f584adcab7b.svg";
export { ForwardRef as ReactComponent };